module.exports = __webpack_public_path__ + "img/lunar-logo.10db2b41.png";